import type { ListingKind } from '@/types/listing'

/**
 * 地点种类的唯一定义。规则见 main-api `docs/location-merge/ARCHITECTURE.md` §4.1：
 * 不写 `kind` 时后端只回 RENTAL；COMPANY、VIRTUAL 要 `asset-mgr:location:read`。
 */
export const LISTING_KINDS: readonly ListingKind[] = ['RENTAL', 'COMPANY', 'VIRTUAL']
export const NON_RENTAL_KINDS: readonly ListingKind[] = ['COMPANY', 'VIRTUAL']
export const DEFAULT_LISTING_KINDS: readonly ListingKind[] = ['RENTAL']
/** 任务类场景：出租房和办公室、仓库。见 PRD §7 */
export const RENTAL_AND_COMPANY_KINDS: readonly ListingKind[] = ['RENTAL', 'COMPANY']
